<template>
  <div id="interview-practice">
    <div class="interview-practice-container">
      <section class="first">
        <div class="renew2_wrapper">
          <h2>AI面接練習</h2>
          <div class="">
            <div class="first-flexright">
              <div class="first01">
                <p class="first01-title">志望企業の情報や志望動機を入力！</p>
                <p class="first01-txt">情報を入力したら、AIがそれに沿った質問内容を考えて、面接の練習ができます。<br>情報は入力しなくても始められます。</p>
              </div>
              <form @submit.prevent="submitForm">
                <div class="form-group">
                  <label for="companyInfo">志望企業の情報</label>
                  <textarea
                  id="companyInfo"
                  v-model="companyInfo"
                  rows="4"
                  placeholder="企業名、業界、特徴など"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label for="motivation">志望動機</label>
                  <textarea
                  id="motivation"
                  v-model="motivation"
                  rows="4"
                  placeholder="なぜこの企業を志望しているのか、どのように貢献したいかなど"
                  ></textarea>
                </div>
                <button type="submit" class="submit-button">ログインして始める</button>
              </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      companyInfo: '',
      motivation: '',
      isSubscribed: false
    }
  },
  mounted () {
  },
  methods: {
    async fetchIsUserPrimeRegistered() {
      if (!this.$firebase.isAuthenticated) {
        console.log('ユーザーがログインしていません')
        return
      }
      try {
        const response = await this.$axios.get(this.$varuna.endPoints.isSubscribed+this.$firebase.user.uid+'/')
        const data = await response.data
        this.isSubscribed = data.is_subscribed

        if (this.isSubscribed) {
          // Prime会員ではない場合は、始めるボタン(submit-button)を会員登録ボタンに変更
          const submitButton = document.querySelector('.submit-button')
          submitButton.textContent = '面接練習を始める'
        } else {
          // Prime会員ではない場合は、始めるボタン(submit-button)を会員登録ボタンに変更
          const submitButton = document.querySelector('.submit-button')
          submitButton.textContent = 'ヤギプライムに登録して始める'
        }

      } catch (error) {
        console.error('Prime会員情報の取得中にエラーが発生しました:', error)
        this.isUserPrimeRegistered = false
      }
    },
    async fetchMotivation () {
      if (!this.$firebase.isAuthenticated) {
        console.log('ユーザーがログインしていません')
        return
      }
      try {
        const response = await this.$axios.post(this.$varuna.endPoints.aiGetMotivation, {
          uuid: this.$firebase.user.uid
        })
        const data = await response.data

        // 志望動機が存在する場合のみセット、ない場合はnullのまま
        this.motivation = data.motivation || null
      } catch (error) {
        console.error('志望動機の取得中にエラーが発生しました:', error)
        this.motivation = null
      }
    },
    submitForm: function () {
      if (!this.$firebase.isAuthenticated) {
        // /loginにリダイレクト
        window.location.href = '/login'
        return
      }
      if (!this.isSubscribed) {
        // Prime会員ではない場合は、/primeにリダイレクト
        window.location.href = '/yagiprime_register'
        return
      }
      this.$emit('form-submitted', {
        companyInfo: this.companyInfo,
        motivation: this.motivation
      })
    },
    authStateChanged: async function () {
      const app = this
      if (this.$firebase.isAuthenticated) {
        await this.fetchIsUserPrimeRegistered()
        // await this.fetchMotivation()
      }
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>

<style scoped>
#interview-practice .renew2_wrapper{
		width: 768px;
	}

	#interview-practice a:hover{
		text-decoration: none;
		opacity: 1;
	}

	#interview-practice h2{
		font-size: 18px;
		color: #004D40;
		text-align: center;
		margin-bottom: 20px;
	}

	#interview-practice h3{
		font-size: 16px;
		color: #004D40;
		text-align: center;
		margin-bottom: 20px;
	}

	#interview-practice .first{
		background: #FFFFE8;
    	padding: 30px 0;
		margin-bottom: 50px;
	}

	#interview-practice .first01{
		margin-bottom: 20px;
	}

	#interview-practice .first01-title{
		color: #E95B10;
		font-weight: bold;
		font-size: 16px;
	}

	#interview-practice .first .renew2_flex{
		justify-content: space-between;
	}

.justify-content-space-around {
  justify-content: space-around;
}

h2 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}

p {
  color: #666;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
}

label:hover {
  color: #333;
  opacity: 1;
}

textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
}

.submit-button {
  background-color: #4CAF50;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  display: block;
  margin: 0 auto;
}

.submit-button:hover {
  background-color: #45a049;
}

@media (max-width: 768px) {
  .pre-interview-form {
    padding: 15px;
  }

  h2 {
    font-size: 20px;
  }

  p {
    font-size: 14px;
  }

  .submit-button {
    width: 100%;
  }
}
</style>
